import { cfgToThemeCdnPath } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const createTurboCanonicalItems = () => [
    {
        id: 'jackpot',
        promotion: {
            id: 'jackpot',
            title: Verbiage.turbo_jackpot_promo_title,
            description: Verbiage.turbo_jackpot_promo_subtitle,
            url: '/promotion-page/jackpot/',
            promotionUrl: '/promotion-page/jackpot/',
            startDate: new Date('2025-02-26T00:00:00Z'),
            noSignUp: true,
            autoBanner: true,
            titleSingleLine: true,
            footerText: 'Turbo Jackpot'
        }
    },
    {
        id: 'welcome-deposit-bonus',
        promotion: {
            id: 'welcome-deposit-bonus',
            title: Verbiage.turboslots_welcome_bonus_headline,
            description: Verbiage.turboslots_welcome_bonus_tile_subtitle,
            buttonText: Verbiage.turboslots_read_more,
            footerText: Verbiage.turboslots_special_for_new_members,
            url: '/promotion-page/welcome-deposit-bonus/',
            promotionUrl: '/promotion-page/welcome-deposit-bonus/',
            banner: cfgToThemeCdnPath('/promotions/welcome_bonus/welcome_bonus.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/welcome_bonus/welcome_bonus-detail.png'),
            startDate: new Date('2026-06-25T00:00:00Z'),
            action: true
        },
        order: { promotions: 0 }
    },
    {
        id: 'turbo-rewards',
        promotion: {
            id: 'turbo-rewards',
            title: Verbiage.turboslots_unlock_your_rewards,
            description: Verbiage.turboslots_unlock_your_rewards_tile_subtitle,
            buttonText: Verbiage.turboslots_read_more,
            footerText: Verbiage.turboslots_special_for_new_members,
            url: '/bonus-terms/',
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/welcome_bonus/welcome_bonus.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/welcome_bonus/welcome_bonus-detail.png'),
            startDate: new Date('2026-06-25T00:00:00Z')
        },
        order: { promotions: 1 }
    }
];
